<div class="dialog-viewer container">
  <h2 mat-dialog-title class="mat-h2 mb-4">Create Membership Customer</h2>
  <div class="row">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
  </div>
  <form [formGroup]="membershipCustomerForm" (ngSubmit)="onSubmit()" class="membership-customer-form">
    <div class="row g-3">
      <div class="col-md-6">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" required />
          <mat-error *ngIf="membershipCustomerForm.get('firstName').hasError('required')">
            First name is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName" required />
          <mat-error *ngIf="membershipCustomerForm.get('lastName').hasError('required')">
            Last name is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Email Address</mat-label>
          <input matInput type="email" formControlName="emailAddress" required />
          <mat-error *ngIf="membershipCustomerForm.get('emailAddress').hasError('required')">
            Email address is required
          </mat-error>
          <mat-error *ngIf="membershipCustomerForm.get('emailAddress').hasError('email')">
            Please enter a valid email address
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Membership Plan</mat-label>
          <mat-select formControlName="membershipPlanId" required>
            <mat-option *ngFor="let plan of membershipPlans" [value]="plan.id" (onSelectionChange)="setMembershipPlan(plan)">
              {{ plan.name }} - {{ plan.price | currency }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="membershipCustomerForm.get('membershipPlanId').hasError('required')">
            Membership plan is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="mb-2 fw-bold">Payment Information</label>
      </div>
      <div class="col-12">
        <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
            <ngx-stripe-card [options]="cardOptions" />
        </ngx-stripe-elements>
    </div>
    </div>
    <div class="row">
      <div class="col-12 text-end">
        <button mat-raised-button color="warn" type="button" (click)="cancel()" class="me-2">
          Cancel
        </button>
        <button mat-raised-button type="submit" [disabled]="!membershipCustomerForm.valid || isLoading">
          Create Customer
        </button>
      </div>
    </div>
  </form>
</div>
